import regexMapGroup from './regexMapGroup';
import { setToHighDpi } from '../constants';
/**
 * This function returns an akamai url that changed to a high DPI image url.
 *
 * @param url - The image url.
 * @returns - Return a url.
 */
const akamaiUrlToHighDpi = (url) => {
    const widthRegex = /imwidth=(?<Size>\d+)/;
    const heightRegex = /imheight=(?<Size>\d+)/;
    const urlNewWidth = regexMapGroup(url, widthRegex, 'Size', setToHighDpi);
    return regexMapGroup(urlNewWidth, heightRegex, 'Size', setToHighDpi);
};
export default akamaiUrlToHighDpi;
//# sourceMappingURL=akamaiUrlToHighDpi.js.map